import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { LiveAgentStrip } from '../components/LiveAgentStrip';
import { ValueProp } from '../components/ValueProp';
import { VerticalSolutions } from '../components/VerticalSolutions';
import { AgentDemo } from '../components/AgentDemo';
import { HowItWorks } from '../components/HowItWorks';
import { DeploymentSection } from '../components/DeploymentSection';
import { BeforeAfter } from '../components/BeforeAfter';
import { TrustSection } from '../components/TrustSection';
import { SocialProof } from '../components/SocialProof';
import { AboutSection } from '../components/AboutSection';
import { CTASection } from '../components/CTASection';
import { SectionDivider } from '../components/SectionDivider';
import { QuietConfidence } from '../components/QuietConfidence';
export function HomePage() {
  return <main className="relative z-10" data-id="element-1048">
      <HeroSection data-id="element-1049" />
      <LiveAgentStrip data-id="element-1050" />
      <SectionDivider data-id="element-1051" />
      <ValueProp data-id="element-1052" />
      <QuietConfidence text="Not built for demos. Built for operations." data-id="element-1053" />
      <VerticalSolutions data-id="element-1054" />
      <SectionDivider data-id="element-1055" />
      <AgentDemo data-id="element-1056" />
      <QuietConfidence text="Where reasoning meets execution." data-id="element-1057" />
      <HowItWorks data-id="element-1058" />
      <SectionDivider data-id="element-1059" />
      <DeploymentSection data-id="element-1060" />
      <QuietConfidence text="Context is everything." data-id="element-1061" />
      <BeforeAfter data-id="element-1062" />
      <SectionDivider data-id="element-1063" />
      <TrustSection data-id="element-1064" />
      <SectionDivider data-id="element-1065" />
      <SocialProof data-id="element-1066" />
      <SectionDivider data-id="element-1067" />
      <AboutSection data-id="element-1068" />
      <SectionDivider data-id="element-1069" />
      <CTASection data-id="element-1070" />
    </main>;
}